import React, { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { hidePopover } from "../store/navSlice";
import pkg from "../../package.json";

import "./Popover.scss";
import { ReactComponent as IconClose } from "../assets/images/close.svg";

const mapDispatch = { hidePopover };
function mapState(state) {
  return {
    popover: state.nav.popover,
    isMobile: state.nav.viewport?.isMobile || false
  };
}

class Popover extends Component {
  constructor(props) {
    super();

    this.basepath = (pkg.homepage || "") + "/content";

    this.state = {
      popoverDelayed: props.popover,
      positioned: false,
      showArrow: true,
      x: 0,
      y: 0
    };

    this.popoverEl = createRef();
    this.image = createRef();
    this.body = createRef();
  }

  componentDidUpdate(prevProps) {
    const popover = this.props.popover;
    const prevPopover = prevProps.popover;

    // Delay unsetting the popover so out transition can play
    if (prevPopover !== null && popover === null) {
      clearInterval(this.timerID);
      this.timerID = setTimeout(() => {
        this.setState({
          popoverDelayed: popover,
          positioned: false,
          showArrow: true,
          x: 0,
          y: 0
        });
      }, 500);
    } else if (prevPopover !== popover) {
      this.setState({
        popoverDelayed: popover,
        positioned: false,
        showArrow: true,
        x: 0,
        y: 0
      });

      if (!this.props.isMobile && !popover?.src?.length) {
        setTimeout(() => {
          this.calcPosition();          
        }, 100);
      }
    }
  }

  onImageLoaded() {
    !this.props.isMobile && this.calcPosition();
  }

  onImageError() {
    this.setState({
      popoverDelayed: {
        ...this.state.popoverDelayed,
        src: ''
      }
    });

    // Allow for broken image tag to be removed before calc
    !this.props.isMobile && setTimeout(() => {
      this.calcPosition();      
    }, 50);
  }

  calcPosition() {
    const popoverEl = this.popoverEl.current;
    const body = this.body.current;

    if (!popoverEl || !body) {
      return;
    }

    const popoverHeight = popoverEl.offsetHeight;
    const bodyOffsetY = body.offsetTop + 30;
    const popoverWidth = popoverEl.offsetWidth;
    const { x, y } = this.state.popoverDelayed;
    const { innerHeight, innerWidth } = window;

    let showArrow = true;
    let targetX = x;
    let targetY = y;

    targetX += 40; // push to the right so the arrow doesn't overlap hotpot
    targetY -= bodyOffsetY;

    // CHECK BOUNDARIES

    // Adjust if it goes above or below viewport
    if (targetY < 0) {
      showArrow = false;
      targetY = 20;
    } else if (targetY + popoverHeight > innerHeight) {
      showArrow = false;
      targetY = innerHeight - popoverHeight - 20;
    }
    
    // Adjust position if goes to the right of viewport (can't go to the left)
    if (targetX + popoverWidth > innerWidth) {
      showArrow = false;
      targetX = innerWidth - popoverWidth - 20;
    }
    
    this.setState({
      positioned: true,
      showArrow,
      x: targetX,
      y: targetY,
    });
  }

  render() {
    const { t, isMobile, popover, hidePopover } = this.props;
    const { popoverDelayed, positioned, x, y, showArrow } = this.state;

    const hasImage = popoverDelayed?.src?.length > 0;
    const transKey = popoverDelayed?.transKey || false;
    const title = transKey ? t(`hotspots.${transKey}_title`) : "";
    const desc = transKey ? t(`hotspots.${transKey}_body`) : "";
    const style = isMobile ? {} : {
      top: `${y}px`,
      left: `${x}px`,
    };

    return (
      <div
        className={`app-popover ${popover && (isMobile || positioned) ? "show" : ""}`}
        onClick={() => hidePopover()}
      >
        <div
          ref={this.popoverEl}
          className={`popover ${showArrow ? "" : "no-arrow"}`}
          style={style}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="head">{title}</div>
          {hasImage && (
            <img
              ref={this.image}
              src={`${this.basepath}/${popoverDelayed.src}`}
              alt={title}
              onLoad={this.onImageLoaded.bind(this)}
              onError={this.onImageError.bind(this)}
            />
          )}
          <div ref={this.body} className="body">
            {desc}
          </div>
          <button
            className="btn btn-circle popover-close"
            onClick={() => hidePopover()}
          >
            <IconClose />
          </button>
        </div>
      </div>
    );
  }
}

export default withTranslation()(connect(mapState, mapDispatch)(Popover));
